import { instance } from "apis/interceptor";
import { TMeetingOverviewDashBoard } from "types/analytics.types";

type ResponseType<T> = {
  success: boolean;
  statusCode?: number;
  message?: string;
  data?: T;
};

type TOverviewMeetingDashBoardRequest = {
  viewStartDate: string;
  viewEndDate: string;
  meetingRoomName?: string;
};

type TMeetingRoomFilterRequest = {
  start: string;
  end: string;
};

//* INFO: 월별 회의실 이용 현황 대시보드 조회하기
export async function getMeetingMonthlyOverviewData(
  data: TOverviewMeetingDashBoardRequest
): Promise<ResponseType<TMeetingOverviewDashBoard>> {
  try {
    const res = await instance.post("/analytics/meeting/dashboard/monthly-status", data);
    return { success: true, data: res.data };
  } catch (error: any) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
}

//* INFO: 월별 회의실 이용 현황 대시보드 내 회의실 이름 조회하기
export async function getMeetingRoomOfMonthlyData(data: TMeetingRoomFilterRequest): Promise<ResponseType<string[]>> {
  try {
    const res = await instance.post("/analytics/meeting/dashboard/monthly-status/meetingroom-name", data);

    return { success: true, data: res.data };
  } catch (error: any) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
}
